"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var NoDataComponent = function NoDataComponent(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "rt-noData"
  }, " ", children || 'You have no activity.', " ");
};

var _default = NoDataComponent;
exports["default"] = _default;